<template>
    <div>
        <div class="content-box">
            <div v-html="params.text"></div>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">已知晓</el-button>
        </p>
    </div>
</template>

<!-- oppo批量 错误计划提示-->
<script>

export default {
    name: "oppoErrorModal",
    props:['cbs', 'params'],
    data(){
        return {
            formLoading: false
        }
    },
    mounted(){
    },
    methods:{
        submitModal(){
            this.cbs.onSubmit()
        },
        hideModal(){
            this.$emit('close');
        },
    }
}
</script>

<style scoped>

</style>
